/* global axios */

const getBaseUrl = (accountId) => `/api/v1/accounts/${accountId}/funnel_items`;

export default {
  // Checklists
  getChecklists(accountId, itemId) {
    return axios.get(`${getBaseUrl(accountId)}/${itemId}/checklists`);
  },

  createChecklist(accountId, itemId, data) {
    return axios.post(`${getBaseUrl(accountId)}/${itemId}/checklists`, data);
  },

  updateChecklist(accountId, itemId, checklistId, data) {
    return axios.patch(`${getBaseUrl(accountId)}/${itemId}/checklists/${checklistId}`, data);
  },

  deleteChecklist(accountId, itemId, checklistId) {
    return axios.delete(`${getBaseUrl(accountId)}/${itemId}/checklists/${checklistId}`);
  },

  toggleChecklist(accountId, itemId, checklistId) {
    return axios.post(`${getBaseUrl(accountId)}/${itemId}/checklists/${checklistId}/toggle`);
  },

  // Notes
  getNotes(accountId, itemId) {
    return axios.get(`${getBaseUrl(accountId)}/${itemId}/notes`);
  },

  createNote(accountId, itemId, content) {
    return axios.post(`${getBaseUrl(accountId)}/${itemId}/notes`, { content });
  },

  updateNote(accountId, itemId, noteId, content) {
    return axios.patch(`${getBaseUrl(accountId)}/${itemId}/notes/${noteId}`, { content });
  },

  deleteNote(accountId, itemId, noteId) {
    return axios.delete(`${getBaseUrl(accountId)}/${itemId}/notes/${noteId}`);
  },

  // Participants
  getParticipants(accountId, itemId) {
    return axios.get(`${getBaseUrl(accountId)}/${itemId}/participants`);
  },

  addParticipant(accountId, itemId, userId) {
    return axios.post(`${getBaseUrl(accountId)}/${itemId}/participants`, { user_id: userId });
  },

  removeParticipant(accountId, itemId, participantId) {
    return axios.delete(`${getBaseUrl(accountId)}/${itemId}/participants/${participantId}`);
  },

  // Labels
  getLabels(accountId, itemId) {
    return axios.get(`${getBaseUrl(accountId)}/${itemId}/labels`);
  },

  addLabel(accountId, itemId, labelId) {
    return axios.post(`${getBaseUrl(accountId)}/${itemId}/labels`, { label_id: labelId });
  },

  removeLabel(accountId, itemId, labelId) {
    return axios.delete(`${getBaseUrl(accountId)}/${itemId}/labels/${labelId}`);
  },

  // Proposals
  getProposals(accountId, itemId) {
    return axios.get(`${getBaseUrl(accountId)}/${itemId}/proposals`);
  },

  createProposal(accountId, itemId, data) {
    return axios.post(`${getBaseUrl(accountId)}/${itemId}/proposals`, data);
  },

  updateProposal(accountId, itemId, proposalId, data) {
    return axios.patch(`${getBaseUrl(accountId)}/${itemId}/proposals/${proposalId}`, data);
  },

  deleteProposal(accountId, itemId, proposalId) {
    return axios.delete(`${getBaseUrl(accountId)}/${itemId}/proposals/${proposalId}`);
  },

  // Activities
  getActivities(accountId, itemId) {
    return axios.get(`${getBaseUrl(accountId)}/${itemId}/activities`);
  },
};
